import Button from "../Button/Button";
import "./SegmentedControl.css";

/**
 * Switch between a few options (tabs / view toggle).
 * options: [{ value, label, icon? }]  icon is a lucide-style component
 * variant "subtle": List / Calendar switch
 * variant "pill":   Pending / Completed tabs
 */
const SegmentedControl = ({ options, value, onChange, variant = "subtle" }) => (
  <div className={`segmented-control segmented-control--${variant}`} role="tablist">
    {options.map(({ value: optionValue, label, icon: Icon }) => (
      <Button
        key={optionValue}
        variant="plain"
        role="tab"
        aria-selected={value === optionValue}
        className={value === optionValue ? "is-active" : ""}
        icon={Icon ? <Icon size={14} /> : null}
        onClick={() => onChange(optionValue)}
      >
        {label}
      </Button>
    ))}
  </div>
);

export default SegmentedControl;
